import React from 'react';
import { ErrorInpage, PageElement, SuccessInpage, UtilsBlock } from '@hz-design-system/web-ui';

import requestStatus, { type RequestStatus } from '../../constants/requestStatus';
import type { Notification } from '../../../../../types/AppState';

type TNotificationsProps = {
  notification: string;
  notifications: Notification[];
  saveSellerRequestStatus: RequestStatus;
};

const Notifications = ({ notification, notifications, saveSellerRequestStatus }: TNotificationsProps) => {
  let combinedNotifications: Notification[] = [];

  // Notification from saveSeller/deleteSeller action
  if (notification) {
    combinedNotifications = combinedNotifications.concat({
      message: notification,
      isSuccess: Boolean(saveSellerRequestStatus === requestStatus.success),
      isError: Boolean(saveSellerRequestStatus === requestStatus.failure),
    });
  }

  combinedNotifications = combinedNotifications.concat(
    notifications.map((notif) => ({
      message: notif.message,
      isSuccess: notif.isSuccess,
      isError: !notif.isSuccess,
    })),
  );

  if (!combinedNotifications.length) {
    return null;
  }

  const [displayableNotification] = combinedNotifications;

  return (
    <PageElement kind="full-width">
      <UtilsBlock marginTop="s" marginBottom="s">
        {displayableNotification.isSuccess && (
          <SuccessInpage
            icon="checkmark-circle"
            description={
              // oxlint-disable-next-line react/no-danger
              (<span dangerouslySetInnerHTML={{ __html: displayableNotification.message }} />) as unknown as string
            }
          />
        )}
        {displayableNotification.isError && (
          <ErrorInpage
            description={
              // oxlint-disable-next-line react/no-danger
              (<span dangerouslySetInnerHTML={{ __html: displayableNotification.message }} />) as unknown as string
            }
            icon="alert"
          />
        )}
      </UtilsBlock>
    </PageElement>
  );
};

export default Notifications;
